import React from 'react';

import { CurricularClass42023 } from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass42023 />;
};

export default ExtraCurricularActivitiesPage;
